import { render, staticRenderFns } from "./PgaBusinessStartupInternalProjectTable.vue?vue&type=template&id=3a0fa8ac&"
import script from "./PgaBusinessStartupInternalProjectTable.vue?vue&type=script&lang=ts&"
export * from "./PgaBusinessStartupInternalProjectTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a0fa8ac')) {
      api.createRecord('3a0fa8ac', component.options)
    } else {
      api.reload('3a0fa8ac', component.options)
    }
    module.hot.accept("./PgaBusinessStartupInternalProjectTable.vue?vue&type=template&id=3a0fa8ac&", function () {
      api.rerender('3a0fa8ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/business-startups/internal-projects/components/table/PgaBusinessStartupInternalProjectTable.vue"
export default component.exports